import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	//font-size: 1rem;
	font-size: clamp(1px, 4.1dvw, 10rem);
	margin-top: 0.8em;
	width: 100%;
	height: 4.8em;
	padding: 0.5em;
	box-sizing: border-box;
	border-radius: 16px;
	background: linear-gradient(90deg, #01babd 0%, #0189a7 100%);
	box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.25);
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 0.4em;

	// to match with sign up incentive banner
	@media (min-width: 820px) {
		font-size: clamp(1px, 1.96dvw, 1.5rem);
		width: 95%;
		max-width: 680px;
	}
`;

export const Title = styled.div`
	color: #fff;
	text-align: left;
	font-family: Inter;
	font-size: 0.95em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.3em;
	white-space: nowrap;
`;

export const SubTitle = styled.div`
	color: #fff;
	font-family: Inter;
	font-size: 0.75em;
	font-style: normal;
	font-weight: 400;
	line-height: 1.2em;
`;

export const Icon = styled.img`
	color: #fff;
	width: 3.5em;
	height: 3.5em;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1.2em;
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0em;
`;
